export const VolumeDurationControlConstants = Object.freeze({
  SLIDER_VISIBILITY_TIMEOUT: 1000,
} as const);

export default VolumeDurationControlConstants;
